import { defineMessages } from 'react-intl';

const messages = defineMessages({
  EmailTemplates: 'Email Templates',
  NoteTemplates: 'Note Templates',
  MeetingTemplates: 'Meeting Templates',
  PhoneTemplates: 'Phone Templates',
  TemplateName: 'Template Name',
  TemplateContext: 'Template Context',
  TemplateLanguages: 'Template languages',
  Actions: 'Actions',
  Add: 'Add',
  DeleteTemplate: 'Delete template',
  DeleteTemplateConfirmationMsg: 'Are you sure you want to delete this template?',
  SearchName: 'Template name',
  AllLanguages: 'Language',
});
export default messages;
